import { DEFAULT_HEATMAP_COLOR_TRADE_AREA_PALETTE_COLORS as t } from "./index.es59.js";
const i = {
  visitorsOrigin: "home",
  metric: "visits",
  minVisits: 1
}, a = {
  showAs: "gradient",
  opacity: 20,
  palette: t[6],
  inEditMode: !0,
  includeLayer: !0,
  legendTitle: "True Trade Area Heat Map"
};
export {
  i as ttaHeatMapDefaultFetchFilter,
  a as ttaHeatMapDefaultVisualFilter
};
//# sourceMappingURL=index.es80.js.map
